import _ from "lodash";
import {returnButton, saveButton} from "../utils";
import {liberalityReversionDepartureFormObjects} from "../staticEntities";
import moment from "moment/moment";
import {basicContext} from "../../../utils/contextUtils";

export const presentButton = nextStatus => ({
    action: 'present',
    type: 'action',
    nextStatus,
    //nextStatus: 'readyToBePresented',
    tKey: 'Présenter',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
})

export const adjourn = {
    action: 'adjourn',
    type: 'action',
    nextStatus: 'incomplete',
    tKey: 'Ajourner',
    bsStyle: 'warning',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}


export const abandonButton = {
    action: 'abandon',
    type: 'action',
    nextStatus: 'abandoned',
    tKey: 'Abandonner',
    bsStyle: 'danger',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const closeButton = {
    action: 'close',
    type: 'action',
    nextStatus: 'closed',
    tKey: 'Clore',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const reviseButton = {
    action: 'revise',
    type: 'action',
    nextStatus: 'revision',
    tKey: 'Réviser',
    bsStyle: 'warning',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const reopenButton = {
    action: 'reopen',
    type: 'action',
    nextStatus: 'reopened',
    tKey: 'Rouvrir',
    bsStyle: 'primary',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const validateButton = {
    action: 'validate',
    type: 'action',
    nextStatus: 'validated',
    tKey: 'Accepter',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const rejectButton = {
    action: 'reject',
    type: 'action',
    nextStatus: 'rejected',
    tKey: 'Renoncer',
    bsStyle: 'danger',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const prepareListButton = {
    type: 'action',
    action: 'prepareList',
    tKey: 'Préparer la liste',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const generateReportButton = {
    type: 'action',
    action: 'generateReport',
    tKey: 'Générer et envoyer le relevé de décisions',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

// Statuts à partir desquels le dossier n'est plus enregistrable
const lockedRecordStatuses = ['abandoned', 'rejected', 'closed']

// Abandonner : tout statut sauf Brouillon et Clos (et Abandon, où l'action serait sans effet)
const canAbandon = statusId => !['draft', 'closed', 'abandoned'].includes(statusId)

export const getButtonsForModule = (file, context) => {
    const statusId = _.get(file, 'status.id')
    const { moduleId } = context.clientContext
    if( moduleId === 'm-C-liberalityRecord') {
        const canSave = !lockedRecordStatuses.includes(statusId)
        const saveButtons = canSave ? [saveButton] : []
        const abandonButtons = canAbandon(statusId) ? [abandonButton] : []
        const hasRealizedAsset = (file.assetsInfos || []).some(asset => asset.netAmount != null || asset.achievedDate)
        const reviseButtons = !hasRealizedAsset && ['validated', 'rejected', 'abandoned'].includes(statusId) ? [reviseButton] : []
        const reopenButtons = statusId === 'closed' ? [reopenButton] : []
        const closeButtons = ['validated', 'reopened'].includes(statusId) ? [closeButton] : []
        if(statusId === 'draft') return [presentButton('readyToBePresented'), ...saveButtons, returnButton]
        // « Révision » se comporte comme « Ajournement »
        if(['incomplete', 'revision'].includes(statusId)) return [presentButton('updated'), ...abandonButtons, ...saveButtons, returnButton]
        return [...reopenButtons, ...closeButtons, ...reviseButtons, ...abandonButtons, ...saveButtons, returnButton]
    }

    if(moduleId === 'm-C-liberalityReversion') {
        const saveButtons = lockedRecordStatuses.includes(statusId) ? [] : [saveButton]
        const abandonButtons = ['closed', 'abandoned'].includes(statusId) ? [] : [abandonButton]
        const closeButtons = ['validated', 'reopened'].includes(statusId) ? [closeButton] : []
        const reopenButtons = statusId === 'closed' ? [reopenButton] : []
        return [...reopenButtons, ...closeButtons, ...abandonButtons, ...saveButtons, returnButton]
    }

    if(moduleId === 'm-C-liberalityDecision') {
        if(statusId === 'awaitingDecision') return [validateButton, rejectButton, abandonButton, adjourn, saveButton, returnButton]
    }

    return [returnButton]
}

export function calculateNetForecast({
                                  typeOfFileId,
                                  distribution = [],
                                  grossAssets = 0,
                                  grossLiabilities = 0,
                                  actsFees = 0,
                                  assets = 0
                              }) {
    // Calculate totals
    const totalSharePercentage = distribution.reduce((total, { share = 0 }) => total + (share / 100), 0);
    const totalOwnLiabilities = distribution.reduce((total, { ownLiabilities = 0 }) => total + ownLiabilities, 0);

    let result;
    // Perform calculation based on type
    switch (typeOfFileId) {
        case 'legs':
            result = (grossAssets - grossLiabilities - actsFees) * totalSharePercentage - totalOwnLiabilities;
            break;
        case 'lifeInsurance':
            result = assets * totalSharePercentage;
            break;
        case 'donations':
        case 'giftsOnInheritance':
            result = (grossAssets - actsFees) * totalSharePercentage;
            break;
        default:
            result = 0;
    }

    return result
}

export function getFieldsByPath(fieldsArray, paths) {
    return fieldsArray.reduce((acc, field) => {
        if (paths.includes(field.path)) {
            acc[field.path] = field;
        }
        return acc;
    }, {});
}

export function calculateReversionMaxAmount(departure) {
    const beneficiaryId = _.get(departure, 'beneficiary.id')
    const assetId = _.get(departure, 'asset.id')
    if (!beneficiaryId || !assetId) return 0

    const liberalityRecord = departure.liberalityRecord || {}
    const assetsInfos = _.get(liberalityRecord, 'assetsInfos') || []
    const assetInfo = assetsInfos.find(asset => `${asset.id}` === `${assetId}`)
    const partition = (assetInfo?.distribution || []).find(dist => `${_.get(dist, 'beneficiary.id')}` === `${beneficiaryId}`)
    const share = partition?.share || 0

    const entriesForAsset = (liberalityRecord.entries || []).filter(entry => `${_.get(entry, 'asset.id')}` === `${assetId}`)

    const receivedForAsset = _.sumBy(entriesForAsset, 'receivedAmount')
    const CNDAShareForAsset = _.sumBy(entriesForAsset, 'CNDAShare')

    const grossShare = receivedForAsset * share / 100
    const CNDAShare = CNDAShareForAsset * share / 100

    const alreadyPaid = _.sumBy(
        (liberalityRecord.departures || []).filter(other =>
            `${other.id}` !== `${departure.id}` &&
            `${_.get(other, 'beneficiary.id')}` === `${beneficiaryId}` &&
            `${_.get(other, 'asset.id')}` === `${assetId}`
        ),
        other => (other.reversionAmount || 0) + (other.advanceRecoveryAmount || 0)
    )

    const debts = _.sumBy(
        _.flatMap(
            (_.get(liberalityRecord, 'receivables') || []).filter(receivable => _.get(receivable, 'status.id') !== 'abandoned'),
            receivable => receivable.imputations || []
        )
            .filter(imputation =>
                `${_.get(imputation, 'beneficiary.id')}` === `${beneficiaryId}` &&
                `${_.get(imputation, 'asset.id')}` === `${assetId}`
            ),
        imputation => Number(imputation.imputedAmount) || 0
    )

    return grossShare - CNDAShare - alreadyPaid - debts
}

export function calculateAdvanceRecoveryMaxAmount(departure) {
    const beneficiaryId = _.get(departure, 'beneficiary.id')
    if (!beneficiaryId || !departure.advance) return 0

    const recordAdvanceRecoveries = (_.get(departure, 'liberalityRecord.departures') || []).filter(other =>
        _.get(other, 'departureForm.id') === 'advanceRecovery' &&
        `${_.get(other, 'beneficiary.id')}` === `${beneficiaryId}`
    )

    // les reprises des autres dossiers sont prises dans les imputations de l'avance, celles du dossier courant depuis ses sorties
    const currentAssetIds = (_.get(departure, 'liberalityRecord.assetsInfos') || []).map(asset => `${asset.id}`)
    const otherRecordsImputedTotal = _.sumBy(
        (departure.advance.imputations || []).filter(imputation => !currentAssetIds.includes(`${_.get(imputation, 'asset.id')}`)),
        imputation => imputation.advanceRecoveryAmount || 0
    )

    const alreadyRecovered = _.sumBy(
        recordAdvanceRecoveries.filter(other => `${other.id}` !== `${departure.id}`),
        other => other.advanceRecoveryAmount || 0
    )

    return (departure.advance.grantedTotal || 0) - otherRecordsImputedTotal - alreadyRecovered
}

const idOf = ref => `${_.get(ref, 'id', ref ?? '')}`
const refs = list => (list || []).map(item => ({id: idOf(item)}))

// Les ids déjà pris en compte par les sorties précédentes du même couple (bénéficiaire, bien)
const getConsumed = previousDepartures => ({
    consumedEntryIds: new Set(_.flatMap(previousDepartures, departure => (departure.includedEntries || []).map(idOf))),
    consumedReceivableIds: new Set(_.flatMap(previousDepartures, departure => (departure.includedReceivables || []).map(idOf)))
})

// Sollicitations accordées des bénéficiaires des nouvelles sorties, et celles déjà prises par une sortie, tous dossiers confondus
export const getSolicitationsData = async (object, oldObject, context) => {
    const oldDepartureIds = new Set((oldObject?.departures || []).map(idOf))
    const beneficiaryIds = _.uniq(
        (object.departures || [])
            .filter(departure => !oldDepartureIds.has(idOf(departure)))
            .map(departure => idOf(departure.beneficiary))
            .filter(Boolean)
    )
    if (!beneficiaryIds.length) return {solicitationsByBeneficiary: {}, consumedSolicitationIds: new Set()}

    const query = {beneficiary: {$in: beneficiaryIds.map(id => new global.ObjectID(id))}}
    const [advances, departures] = await Promise.all([
        global.app.C.LiberalityAdvance.find({
            ...basicContext(context),
            query,
            fieldPath: ['beneficiary.id', 'solicitations.id', 'solicitations.status.id', 'solicitations.grantedAmount']
        }),
        global.app.C.LiberalityReversionDeparture.find({
            ...basicContext(context),
            query,
            fieldPath: ['id', 'includedSolicitations.id']
        })
    ])

    return {
        solicitationsByBeneficiary: _.fromPairs(advances.map(advance => [
            idOf(advance.beneficiary),
            (advance.solicitations || []).filter(solicitation => solicitation.status?.id === 'accepted')
        ])),
        consumedSolicitationIds: new Set(_.flatMap(departures, departure => (departure.includedSolicitations || []).map(idOf)))
    }
}

// Pour chaque nouvelle sortie, enregistre les fonds reçus, les dettes et les sollicitations pris en compte
export const assignDepartureLinks = (object, oldObject, {solicitationsByBeneficiary = {}, consumedSolicitationIds = new Set()} = {}) => {
    const oldDepartures = _.keyBy(oldObject?.departures || [], departure => idOf(departure))
    const departures = object.departures || []
    const entries = object.entries || []
    const receivables = object.receivables || []

    const processed = departures.filter(departure => oldDepartures[idOf(departure)])

    const newDepartures = departures.filter(departure => !oldDepartures[idOf(departure)])

    // L'ordre des départs existants est conservé, les nouveaux sont numérotés à la suite
    let lastOrder = _.max(processed.map(departure => departure.order || 0)) || 0

    newDepartures.forEach(departure => {
        departure.order = ++lastOrder
        // Versement et reprise d'avance consomment tous deux les fonds et les dettes
        const assetId = idOf(departure.asset)
        const beneficiaryId = idOf(departure.beneficiary)

        // Les fonds du bien ne comptent que si le bénéficiaire y a une répartition
        const asset = (object.assetsInfos || []).find(assetInfo => idOf(assetInfo) === assetId)
        const hasPartition = (asset?.distribution || []).some(partition => idOf(partition.beneficiary) === beneficiaryId)
        const candidateEntries = hasPartition ? entries.filter(entry => idOf(entry.asset) === assetId) : []
        const candidateReceivables = receivables.filter(receivable =>
            receivable.status?.id !== 'abandoned' &&
            (receivable.imputations || []).some(imputation =>
                idOf(imputation.beneficiary) === beneficiaryId &&
                idOf(imputation.asset) === assetId &&
                (imputation.imputedAmount || 0) > 0
            )
        )

        const previousDepartures = processed.filter(other => idOf(other.beneficiary) === beneficiaryId && idOf(other.asset) === assetId)
        const {consumedEntryIds, consumedReceivableIds} = getConsumed(previousDepartures)

        departure.includedEntries = refs(candidateEntries.filter(entry => !consumedEntryIds.has(idOf(entry))))
        departure.includedReceivables = refs(candidateReceivables.filter(receivable => !consumedReceivableIds.has(idOf(receivable))))

        // Les sollicitations relèvent de l'avance du bénéficiaire : une fois prises, elles le sont pour tous ses dossiers
        departure.includedSolicitations = refs((solicitationsByBeneficiary[beneficiaryId] || []).filter(solicitation => !consumedSolicitationIds.has(idOf(solicitation))))
        departure.includedSolicitations.forEach(solicitation => consumedSolicitationIds.add(solicitation.id))

        processed.push(departure)
    })

    return newDepartures
}


const formName = formId => _.get(liberalityReversionDepartureFormObjects.find(form => form.id === formId), 'name', '')
// Même formatage que getFormattedAmount (components/AgGrid/columnUtils.js), avec 2 décimales, en français
const amount = value => new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value || 0)

const buildComment = (departure, object, solicitationsByBeneficiary) => {
    const beneficiaryId = idOf(departure.beneficiary)
    const assetId = idOf(departure.asset)
    const isReversion = departure.departureForm?.id === 'reversion'

    const asset = (object.assetsInfos || []).find(assetInfo => idOf(assetInfo) === assetId)
    const partition = (asset?.distribution || []).find(dist => idOf(dist.beneficiary) === beneficiaryId)
    const share = (partition?.share || 0) / 100




    // reversionMaxAmount déduit toutes les autres sorties du couple : on réintègre celles qui sont postérieures à celle-ci
    const laterPaid = _.sumBy(
        (object.departures || []).filter(other =>
            idOf(other) !== idOf(departure) &&
            (other.order || 0) > (departure.order || 0) &&
            idOf(other.beneficiary) === beneficiaryId &&
            idOf(other.asset) === assetId
        ),
        other => (other.reversionAmount || 0) + (other.advanceRecoveryAmount || 0)
    )

    const maxAmount = (departure.reversionMaxAmount || 0) + laterPaid
    const departureAmount = isReversion ? departure.reversionAmount : departure.advanceRecoveryAmount

    // Fonds reçus et dettes pris en compte par cette sortie
    const includedEntryIds = (departure.includedEntries || []).map(idOf)
    const includedEntries = (object.entries || []).filter(entry => includedEntryIds.includes(idOf(entry)))
    const received = _.sumBy(includedEntries, 'receivedAmount') * share
    const CNDAShare = _.sumBy(includedEntries, 'CNDAShare') * share

    const includedReceivableIds = (departure.includedReceivables || []).map(idOf)
    const debts = _.sumBy(
        _.flatMap(
            (object.receivables || []).filter(receivable => includedReceivableIds.includes(idOf(receivable))),
            receivable => receivable.imputations || []
        ).filter(imputation => idOf(imputation.beneficiary) === beneficiaryId && idOf(imputation.asset) === assetId),
        imputation => Number(imputation.imputedAmount) || 0
    )

    // Sollicitations prises en compte par cette sortie
    const includedSolicitationIds = (departure.includedSolicitations || []).map(idOf)
    const advanceReceived = _.sumBy(
        (solicitationsByBeneficiary[beneficiaryId] || []).filter(solicitation => includedSolicitationIds.includes(idOf(solicitation))),
        solicitation => Number(solicitation.grantedAmount) || 0
    )
    // advanceRecoveryMaxAmount déduit toutes les autres reprises d'avance du bénéficiaire dans le dossier : on réintègre celles qui sont postérieures à celle-ci
    const laterAdvanceRecovered = _.sumBy(
        (object.departures || []).filter(other =>
            idOf(other) !== idOf(departure) &&
            (other.order || 0) > (departure.order || 0) &&
            other.departureForm?.id === 'advanceRecovery' &&
            idOf(other.beneficiary) === beneficiaryId
        ),
        other => other.advanceRecoveryAmount || 0
    )

    const advanceInitial = (departure.advanceRecoveryMaxAmount || 0) - advanceReceived + laterAdvanceRecovered
    return [
        '<b>Nouvelle reversion :</b>',
        `Date : ${moment.utc(departure.date).format('YYYY-MM-DD')}`,
        `Bénéficiaire : ${departure.beneficiary?.zipCode || ''} - ${departure.beneficiary?.tradingName || ''}`,
        `Bien : ${asset?.identifier || ''}`,
        `Forme : ${formName(departure.departureForm?.id)}`,
        '------------------------------',
        `Provision initiale (€) : ${amount((maxAmount || 0) - received + CNDAShare + debts)}`,
        `(+) Reçu (€) : ${amount(received)}`,
        `(-) Part CNDA (€) : ${amount(CNDAShare)}`,
        `(-) Dettes (€) : ${amount(debts)}`,
        `(-) Versement (€) : ${amount(departure.reversionAmount || 0)}`,
        `(-) Reprise d'avance (€) : ${amount(departure.advanceRecoveryAmount || 0)}`,
        `(=) Provision finale (€) : ${amount(maxAmount - (departureAmount || 0))}`,
        '------------------------------',
        `Avance sur legs initiale (€) : ${amount(advanceInitial)}`,
        `(+) Avance sur legs reçu (€) : ${amount(advanceReceived)}`,
        `(-) Reprise d'avance (€) : ${amount(departure.advanceRecoveryAmount || 0)}`,
        `(=) Avance sur legs finale (€) : ${amount(advanceInitial + advanceReceived - (departure.advanceRecoveryAmount || 0))}`,
    ].join('<br>')
}

// Ajoute à la zone d'échanges, au nom de l'utilisateur, un commentaire pour chaque nouvelle ligne de reversion
export const addReversionComments = (newDepartures, object, context, {solicitationsByBeneficiary = {}} = {}) => {
    newDepartures.forEach(departure => {
        object.conversations.push({
            text: buildComment(departure, object, solicitationsByBeneficiary),
            sender: _.pick(context.user, ['id', 'name']),
            seenBy: [context.user.id],
            files: [],
            timestamp: new Date().toISOString(),
            from: 'user'
        })
    })
}
